import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {

  transform(phoneNumber: string): string {
    if (!phoneNumber) {
      return '';
    }

    // Assuming the phone number is in the format "1234567890"
    const formattedNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1)$2-$3');
    return formattedNumber;
  }

}
